<template>
  <el-tooltip effect="dark" :placement="placement" :popper-class="popperClass" :open-delay="openDelay">
    <slot name="content" slot="content">
      <div slot="content" v-html="contentHtml"></div>
    </slot>
    <slot><i ref="iconEl" class="tooltip-icon" :class="icon"></i></slot>
  </el-tooltip>
</template>

<script>
import FormatUtil from '../../utils/format'
import CommonUtil from '../../utils/common'

export default {
  name: 'TooltipIconCmp',
  props: {
    content: null,
    placement: {type: String, default: 'right'},
    popperClass: '',
    icon: {type: String, default: 'el-icon-question'},
    openDelay: {type: Number, default: 0}
  },
  mounted () {
    if (CommonUtil.isNotNull(this.$refs.iconEl)) {
      this.$refs.iconEl.setAttribute('tabindex', '-1')
    }
  },
  computed: {
    contentHtml () {
      let content = this.content
      if (CommonUtil.isFunction(content)) {
        content = (content).call(this.$parent)
      }
      return FormatUtil.escapeHtml(content, {
        nl2br: true
      })
    }
  }
}
</script>

<style scoped>
  .tooltip-icon {
    font-size: 1.2rem;
    padding: 3px 4px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/tooltip/tooltip-icon.vue